var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDecorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 353,
    height: 201,
    viewBox: "0 0 353 201",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.145 201C299.787 201 353 156.005 353 100.5C353 44.9953 299.787 -2.32603e-06 234.145 -5.19533e-06L0 -1.54301e-05L-8.78599e-06 201L234.145 201Z",
    fill: "#075E80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDecorImg);
export default __webpack_public_path__ + "static/media/login-decor-img.1a6551241c675b72c654690071f94af0.svg";
export { ForwardRef as ReactComponent };